import { routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { applyMiddleware, compose, StoreEnhancer } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import logger from 'redux-logger';

import afterMiddleware from './after.middleware';
import injectMiddleware from './inject.middleware';

export default function createMiddleware(history: History): StoreEnhancer {
    const middlewaresToApply = [routerMiddleware(history), afterMiddleware, injectMiddleware];
    if (process.env.NODE_ENV !== 'production') {
        middlewaresToApply.push(logger);
    }
    const middlewares = applyMiddleware(...middlewaresToApply);

    return process.env.NODE_ENV === 'production' ? compose(middlewares) : composeWithDevTools(middlewares);
}
